import * as React from 'react';

export function SvgEdgeLogo(props: any) {
  return (
    <svg
      width="96"
      height="97"
      viewBox="0 0 96 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_2_3904)">
        <path
          d="M86.6625 71.8734C85.3752 72.5424 84.0476 73.131 82.6875 73.6359C78.3808 75.2389 73.8203 76.0519 69.225 76.0359C51.4875 76.0359 36.0375 63.8484 36.0375 48.1734C36.0606 46.0745 36.6425 44.0196 37.7234 42.2202C38.8044 40.4208 40.3452 38.942 42.1875 37.9359C26.1375 38.6109 22.0125 55.3359 22.0125 65.1234C22.0125 92.8734 47.55 95.6484 53.0625 95.6484C56.025 95.6484 60.4875 94.7859 63.1875 93.9234L63.675 93.7734C74.0077 90.2026 82.8163 83.2192 88.65 73.9734C88.8195 73.6925 88.8923 73.3637 88.8571 73.0375C88.8219 72.7113 88.6808 72.4056 88.4552 72.1673C88.2297 71.9289 87.9322 71.7712 87.6084 71.7181C87.2846 71.665 86.9523 71.7196 86.6625 71.8734Z"
          fill="url(#paint0_linear_2_3904)"
        />
        <path
          opacity="0.35"
          d="M86.6625 71.8734C85.3752 72.5424 84.0476 73.131 82.6875 73.6359C78.3808 75.2389 73.8203 76.0519 69.225 76.0359C51.4875 76.0359 36.0375 63.8484 36.0375 48.1734C36.0606 46.0745 36.6425 44.0196 37.7234 42.2202C38.8044 40.4208 40.3452 38.942 42.1875 37.9359C26.1375 38.6109 22.0125 55.3359 22.0125 65.1234C22.0125 92.8734 47.55 95.6484 53.0625 95.6484C56.025 95.6484 60.4875 94.7859 63.1875 93.9234L63.675 93.7734C74.0077 90.2026 82.8163 83.2192 88.65 73.9734C88.8195 73.6925 88.8923 73.3637 88.8571 73.0375C88.8219 72.7113 88.6808 72.4056 88.4552 72.1673C88.2297 71.9289 87.9322 71.7712 87.6084 71.7181C87.2846 71.665 86.9523 71.7196 86.6625 71.8734Z"
          fill="url(#paint1_radial_2_3904)"
        />
        <path
          d="M39.6375 90.9234C36.2996 88.8502 33.4062 86.1353 31.125 82.9359C28.52 79.3703 26.7269 75.2779 25.8714 70.9458C25.016 66.6137 25.119 62.1469 26.1731 57.8588C27.2273 53.5707 29.2071 49.5653 31.9736 46.1235C34.7401 42.6818 38.2263 39.8872 42.1875 37.9359C43.3875 37.3734 45.375 36.3984 48.0375 36.4359C49.911 36.4504 51.7558 36.898 53.4277 37.7437C55.0996 38.5894 56.5532 39.8102 57.675 41.3109C59.1838 43.34 60.0109 45.7949 60.0375 48.3234C60.0375 48.2484 69.225 18.4734 30.0375 18.4734C13.575 18.4734 0.0374987 34.0734 0.0374987 47.7984C-0.0279818 55.0485 1.52204 62.2221 4.575 68.7984C9.57477 79.4447 18.3095 87.8848 29.1211 92.5163C39.9327 97.1479 52.0686 97.6486 63.225 93.9234C59.3164 95.1578 55.1864 95.5289 51.1204 95.0109C47.0543 94.493 43.1493 93.0983 39.675 90.9234H39.6375Z"
          fill="url(#paint2_linear_2_3904)"
        />
        <path
          opacity="0.41"
          d="M39.6375 90.9234C36.2996 88.8502 33.4062 86.1353 31.125 82.9359C28.52 79.3703 26.7269 75.2779 25.8714 70.9458C25.016 66.6137 25.119 62.1469 26.1731 57.8588C27.2273 53.5707 29.2071 49.5653 31.9736 46.1235C34.7401 42.6818 38.2263 39.8872 42.1875 37.9359C43.3875 37.3734 45.375 36.3984 48.0375 36.4359C49.911 36.4504 51.7558 36.898 53.4277 37.7437C55.0996 38.5894 56.5532 39.8102 57.675 41.3109C59.1838 43.34 60.0109 45.7949 60.0375 48.3234C60.0375 48.2484 69.225 18.4734 30.0375 18.4734C13.575 18.4734 0.0374987 34.0734 0.0374987 47.7984C-0.0279818 55.0485 1.52204 62.2221 4.575 68.7984C9.57477 79.4447 18.3095 87.8848 29.1211 92.5163C39.9327 97.1479 52.0686 97.6486 63.225 93.9234C59.3164 95.1578 55.1864 95.5289 51.1204 95.0109C47.0543 94.493 43.1493 93.0983 39.675 90.9234H39.6375Z"
          fill="url(#paint3_radial_2_3904)"
        />
        <path
          d="M57.15 56.2359C56.8125 56.6109 55.875 57.1734 55.875 58.3359C55.875 59.3109 56.5125 60.2859 57.675 61.0734C63.0375 64.8234 73.2 64.2984 73.2375 64.2984C77.2352 64.2958 81.159 63.2209 84.6 61.1859C88.0643 59.1596 90.9387 56.2631 92.9384 52.7834C94.9381 49.3037 95.9935 45.3617 96 41.3484C96.1125 32.9484 93 27.3609 91.7625 24.8859C83.775 9.36091 66.6375 0.435913 48 0.435913C35.3857 0.434666 23.2779 5.39903 14.2953 14.2553C5.31272 23.1116 0.177389 35.1479 0 47.7609C0.1875 34.0734 13.8 23.0109 30 23.0109C31.3125 23.0109 38.8125 23.1234 45.75 26.7609C50.6239 29.1829 54.6601 33.01 57.3375 37.7484C59.625 41.7234 60.0375 46.7859 60.0375 48.8109C60.0375 50.8359 59.025 53.7984 57.1125 56.2734L57.15 56.2359Z"
          fill="url(#paint4_radial_2_3904)"
        />
        <path
          d="M57.15 56.2359C56.8125 56.6109 55.875 57.1734 55.875 58.3359C55.875 59.3109 56.5125 60.2859 57.675 61.0734C63.0375 64.8234 73.2 64.2984 73.2375 64.2984C77.2352 64.2958 81.159 63.2209 84.6 61.1859C88.0643 59.1596 90.9387 56.2631 92.9384 52.7834C94.9381 49.3037 95.9935 45.3617 96 41.3484C96.1125 32.9484 93 27.3609 91.7625 24.8859C83.775 9.36091 66.6375 0.435913 48 0.435913C35.3857 0.434666 23.2779 5.39903 14.2953 14.2553C5.31272 23.1116 0.177389 35.1479 0 47.7609C0.1875 34.0734 13.8 23.0109 30 23.0109C31.3125 23.0109 38.8125 23.1234 45.75 26.7609C50.6239 29.1829 54.6601 33.01 57.3375 37.7484C59.625 41.7234 60.0375 46.7859 60.0375 48.8109C60.0375 50.8359 59.025 53.7984 57.1125 56.2734L57.15 56.2359Z"
          fill="url(#paint5_radial_2_3904)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_2_3904"
          x1="22.0125"
          y1="66.8109"
          x2="88.9125"
          y2="66.8109"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0C59A4" />
          <stop offset="1" stopColor="#114A8B" />
        </linearGradient>
        <radialGradient
          id="paint1_radial_2_3904"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(58.95 67.3153) scale(35.775 33.9863)"
        >
          <stop offset="0.7" stopOpacity="0" />
          <stop offset="0.9" stopOpacity="0.5" />
          <stop offset="1" />
        </radialGradient>
        <linearGradient
          id="paint2_linear_2_3904"
          x1="57.2625"
          y1="37.7859"
          x2="15.525"
          y2="83.2734"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#1B9DE2" />
          <stop offset="0.2" stopColor="#1595DF" />
          <stop offset="0.7" stopColor="#0680D7" />
          <stop offset="1" stopColor="#0078D4" />
        </linearGradient>
        <radialGradient
          id="paint3_radial_2_3904"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(26.4581 75.0373) rotate(-81.3844) scale(53.7698 43.4406)"
        >
          <stop offset="0.8" stopOpacity="0" />
          <stop offset="0.9" stopOpacity="0.5" />
          <stop offset="1" />
        </radialGradient>
        <radialGradient
          id="paint4_radial_2_3904"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(9.70875 18.1794) rotate(92.2906) scale(75.9607 161.781)"
        >
          <stop stopColor="#35C1F1" />
          <stop offset="0.1" stopColor="#34C1ED" />
          <stop offset="0.2" stopColor="#2FC2DF" />
          <stop offset="0.3" stopColor="#2BC3D2" />
          <stop offset="0.7" stopColor="#36C752" />
        </radialGradient>
        <radialGradient
          id="paint5_radial_2_3904"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(90.0225 29.4234) rotate(73.7398) scale(36.4875 29.6716)"
        >
          <stop stopColor="#66EB6E" />
          <stop offset="1" stopColor="#66EB6E" stopOpacity="0" />
        </radialGradient>
        <clipPath id="clip0_2_3904">
          <rect
            width="96"
            height="96"
            fill="white"
            transform="translate(0 0.435913)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
